import React from "react";
import { useNavigate } from "react-router-dom";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-5" data-testid="checkout-cancel-page">
      <section>
        <div className="font-mono-rs text-[10px] tracking-[0.22em] uppercase text-[var(--rs-amber)]">RigSentinel · Billing</div>
        <h2 className="font-heading font-black text-3xl tracking-tight mt-1" data-testid="checkout-cancel-title">Checkout cancelled</h2>
        <p className="text-sm text-[var(--rs-text-2)] mt-1.5 leading-relaxed">
          You closed the checkout before completing payment. No charge was made.
        </p>
      </section>
      <section className="card-rs p-4">
        <div className="flex gap-2 flex-wrap">
          <button data-testid="cancel-view-plans-btn" onClick={() => navigate("/pricing")} className="btn-amber h-9 px-3 rounded-md label-up text-xs">Back to pricing</button>
          <button data-testid="cancel-go-home-btn" onClick={() => navigate("/")} className="btn-ghost h-9 px-3 rounded-md label-up text-xs">Continue to RigSentinel</button>
        </div>
      </section>
    </div>
  );
}
